/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Vivid_Still_Ant_HowlInputs */

const en_vivid_still_ant_howl = /** @type {(inputs: Vivid_Still_Ant_HowlInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Delete finished`)
};

const de_vivid_still_ant_howl = /** @type {(inputs: Vivid_Still_Ant_HowlInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Löschen erfolgreich`)
};

/**
* | output |
* | --- |
* | "Delete finished" |
*
* @param {Vivid_Still_Ant_HowlInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const vivid_still_ant_howl = /** @type {((inputs?: Vivid_Still_Ant_HowlInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Vivid_Still_Ant_HowlInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_vivid_still_ant_howl(inputs)
	return de_vivid_still_ant_howl(inputs)
});